import { Target } from "lucide-react";
import {
  ImpactEffortParamsSchema,
  defaultImpactEffortParams,
  type ImpactEffortParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { ImpactEffortWidget } from "./Component.js";

export const impactEffortDef: WidgetDef<ImpactEffortParams> = {
  kind: "impactEffort",
  label: "Impact / Effort Matrix",
  modes: ["canvas"],
  singleton: true,
  defaultSize: { w: 752, h: 384 },
  defaultParams: defaultImpactEffortParams,
  Component: ImpactEffortWidget,
  storage: "sql",
  schema: ImpactEffortParamsSchema,
  accent: "emerald",
  icon: Target,
  subtitle: "Kaizen quadrant — drag to reposition",
  defaultRoster: true,
  category: "single",
  layout: { col: "full", row: 0, width: 752, height: 360 },
  expandable: true,
  renderFooter: (data) => {
    const quickWins = data.points.filter(
      (p) => p.impact > 5 && p.effort <= 5,
    ).length;
    return {
      left: `${data.points.length} idea${data.points.length === 1 ? "" : "s"} · ${quickWins} quick wins`,
      right: "Expand to drag",
    };
  },
};

registerWidget(impactEffortDef);
